import $ from 'jquery';
import { Modal } from 'bootstrap';
import { Form } from '@/components/form/form';
import { destroyAlert, displayError } from './utils';
export class FormContact {
    constructor() {
        this.selector = '.form-contact';
        if ($(this.selector).length === 0)
            return;
        new Form(this.selector, {
            onLoading: () => {
                destroyAlert($(this.selector));
            },
            onSuccess: (data) => {
                const $form = $(this.selector);
                const $parentModal = $form.parents('.modal');
                const { thankyouId } = $form.data();
                const $modalThankYou = $(thankyouId);
                if ($parentModal.length) {
                    const parentModal = Modal.getOrCreateInstance($parentModal[0]);
                    parentModal.hide();
                }
                if ($modalThankYou.length) {
                    const thankyouModal = new Modal($modalThankYou[0]);
                    thankyouModal.show();
                }
                ;
            },
            onError: (error) => {
                displayError($(this.selector), $(this.selector).find('.form-group:last'), error);
            },
        });
    }
}
